import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../..';
import putContext from './put-context';

const requestTopLevelCustomer = createAsyncThunk(
  'api/request-top-level-customer',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;

    const context = state.api.context;

    if (!context) {
      throw new Error('Context is not available');
    }

    if (context.enforce === 'customer') {
      return null;
    }

    await thunkAPI.dispatch(
      putContext({
        customer_group_uuid: null,
        customer_uuid: context.customer_uuid,
      }),
    );

    return null;
  },
);

export default requestTopLevelCustomer;
